import { Ad, ApiBooking, ApiMatSpecs } from "store/features/materialSpecs/ad/interfaces";

const getFirstInsertionDate = (matSpecs: ApiMatSpecs[], matSpecId: number): string => {
    const matSpec = matSpecs.find((matSpec) => matSpec.id === matSpecId);

    return matSpec?.firstinsertiondate || "";
};

export const buildAdModel = (loadBooking: ApiBooking, matSpecId: string): Ad => {
    return {
        orderNumber: loadBooking.ad.orderno,
        dueDate: getFirstInsertionDate(loadBooking.matspecs, parseInt(matSpecId)),
        salesRep: {
            name: loadBooking.ad.salesrep?.name || "",
            email: loadBooking.ad.salesrep?.email || "",
            phone: loadBooking.ad.salesrep?.phone || "",
        },
        customer: {
            id: loadBooking.ad.customers[0].id,
            name: loadBooking.ad.customers[0].name,
        },
    };
};
